import { cva } from 'class-variance-authority';

import { LoadingText } from '@/components/loaders';
import { cn } from '@/lib/utils';

import Markdown from './Markdown';

type LoadingProps = {
  type: 'loading';
  children: string;
};

type OtherProps = {
  type: 'ai' | 'user' | 'error';
  children: string;
};

type Props = (LoadingProps | OtherProps) & {
  className?: string;
};

const messageVariants = cva(['lg:w-[90%] md:w-[95%] w-full rounded-xs'], {
  variants: {
    type: {
      ai: 'bg-aqua-400/30 self-end',
      user: 'bg-gray-400 self-start',
      error: 'bg-red-400/30 self-end',
      loading: 'bg-aqua-400/30 self-end',
    },
  },
});

const AIMessage = ({ className, type, children }: Props) => {
  const content =
    type === 'ai' ? (
      <Markdown>{children}</Markdown>
    ) : type === 'loading' ? (
      <LoadingText label={children} />
    ) : (
      children
    );

  return (
    <div className={cn(messageVariants({ type }), className)}>
      <div className="overflow-x-auto px-6 py-4">{content}</div>
    </div>
  );
};

export default AIMessage;
